import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.keyHighlight
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.keyHighlight
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.keyHighlight
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.keyHighlight
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log('error', err);
          commit(mutations.LOADED);
          return err;
        });
    },
    delete({ commit }, id) {
      commit(mutations.LOADING);
      return api.keyHighlight
        .delete(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    getActive({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.keyHighlight
        .getActive(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    geSystemtActive({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.keyHighlight
        .geSystemtActive(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    }
  }
};
